import { TradingOfferType } from 'types/TradingOffer';

type ResolveTradingOfferOperationPartiesArgs = {
  offerType: TradingOfferType;
  publisherPartnerId: string;
  participantPartnerId: string;
};

export const resolveTradingOfferOperationParties = ({
  offerType,
  publisherPartnerId,
  participantPartnerId,
}: ResolveTradingOfferOperationPartiesArgs): {
  buyer: string;
  seller: string;
} => {
  const isSell = offerType === TradingOfferType.SELL;
  return {
    buyer: isSell ? participantPartnerId : publisherPartnerId,
    seller: isSell ? publisherPartnerId : participantPartnerId,
  };
};
